
import { defineComponent, onMounted, ref } from "vue";
import BModal from "./Modal.vue";
import useUser from "@/store/UserState";
import useNotification from "@/store/NotificationState";

interface LikertOption {
  src: string;
  label: string;
  index: number;
}

export default defineComponent({
  name: "LikertModal",
  components: {
    BModal,
  },
  setup(_, ctx) {
    const { user: patient, sendLikertSurvey, shouldOpenLikert, updateLastTimeOpened } = useUser();
    const { showSnackbar, SnackbarMessageLevel } = useNotification()
    function onCloseClick() {
      ctx.emit("on-close-click");
    }

    let toggle = ref(false);
    function open() {
      toggle.value = true;
    }

    onMounted(() => {
      setTimeout(() => {
        if (shouldOpenLikert()) {
          toggle.value = true;
          updateLastTimeOpened()
        }
      }, 1000);
    });

    let likertOptions: LikertOption[] = [
      { src: require("@/assets/mad.svg"), label: "confused", index: 0 },
      { src: require("@/assets/sad.svg"), label: "sad", index: 1 },
      { src: require("@/assets/confused.svg"), label: "confused", index: 2 },
      { src: require("@/assets/smiling.svg"), label: "smiling", index: 3 },
      { src: require("@/assets/happy.svg"), label: "happy", index: 4 },
    ];

    let selectedScale = ref(-1);
    const selectScale = (score: number) => {
      selectedScale.value = score;
    };
    async function sendSurvey() {
      // do logic stuff here
      if (selectedScale.value === -1) {
        showSnackbar('Debes seleccionar un estado', {
          level: SnackbarMessageLevel.DANGER
        })
        return;
      }
      await sendLikertSurvey(selectedScale.value);
      toggle.value = false;
      showSnackbar('Escala enviado correctamente', {
        level: SnackbarMessageLevel.INFO
      })
    }
    return {
      toggle,
      patient,
      onCloseClick,
      likertOptions,
      sendSurvey,
      open,
      selectScale,
      selectedScale,
    };
  },
});
